"use client";

import React, { useEffect } from "react";
import { Text } from "@dxp-feed/ui";
import dashboardGuide from "./dashboardGuide";

const CustomGuideCard = ({
  step,
  currentStep,
  totalSteps,
  nextStep,
  prevStep,
  skipTour,
  arrow,
}: any) => {
  let isWelcomeStep = false;
  if (step?.isWelcomePage) {
    isWelcomeStep = true;
  }
  // Add and remove a class from body based on isOpen
  useEffect(() => {
    //adding class for background scrolling stop
    document.body.classList.add("custom-guide-active");
    window.dispatchEvent(new Event("guide-activated"));
  }, []);

  return (
    <div
      className={`bg-brandWhite rounded-lg shadow-lg p-4 
        w-full max-w-[688px] sm:max-w-[500px] max-sm:max-w-[90vw]
        min-w-[240px] 2xs:min-w-[260px]  [&_path]:fill-[#fff]
        ${isWelcomeStep ? "lg:w-[688px]" : ""}
        `}
      role="dialog"
    >
      {step.showSkip && (
        <div className="flex justify-end mb-2">
          <main>
            <button
              onClick={skipTour}
              className="text-xs underline text-brandBlack"
              aria-label="Skip Tour"
            >
              skip tour
            </button>
          </main>
        </div>
      )}
      <main>
        <div className="flex items-center gap-2 justify-center text-center mb-2">
          {step.icon && <div className="text-2xl">{step.icon}</div>}
          {step.title && (
            <h3 className="text-lg md:text-xl font-bold">{step.title}</h3>
          )}
        </div>
        <div
          className="mb-2 text-[14px] text-center leading-relaxed px-1 sm:h-full max-h-[142px]
        overflow-y-auto"
        >
          {step.content}
        </div>
      </main>
      {arrow && <div className="mb-3">{arrow}</div>}

      <div className="flex justify-between items-center">
        <main>
          {currentStep > 0 ? (
            <button onClick={prevStep} aria-label="Previous Step">
              <Text
                as="span"
                className="icon icon-left-arrow text-brandBlack text-sm font-bold"
              ></Text>
              <span className="sr-only">Previous</span>
            </button>
          ) : (
            <span />
          )}
        </main>
        <main>
          <span className="text-brandBlack text-body font-bold">
            {`${currentStep + 1}/${totalSteps}`}
          </span>
        </main>
        <main>
          <button
            aria-label={
              currentStep === totalSteps - 1
                ? "Close Tour"
                : isWelcomeStep
                  ? "Start Tour"
                  : "Next Step"
            }
            onClick={nextStep}
          >
            {currentStep === totalSteps - 1 ? (
              <span className="text-brandBlack underline text-body font-bold">
                close
              </span>
            ) : (
              <>
                {isWelcomeStep && (
                  <Text
                    as="span"
                    className="text-brandBlack no-underline hover:underline text-body font-bold mr-2"
                  >
                    start
                  </Text>
                )}
                <Text
                  as="span"
                  className="icon icon-left-arrow text-brandBlack text-sm font-bold rotate-[180deg] inline-block align-middle"
                ></Text>
                <span className="sr-only">
                  {isWelcomeStep ? "Start" : "Next"}
                </span>
              </>
            )}
          </button>
        </main>
      </div>
    </div>
  );
};

export default CustomGuideCard;
